module.exports = __webpack_public_path__ + "static/media/train.bec4e6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/train.png
// module id = 629
// module chunks = 0